"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeightFieldView = exports.Styles = exports.CSS = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var IkeModel = tslib_1.__importStar(require("@ikegps/core-shared"));
var core_shared_1 = require("@ikegps/core-shared");
var field_action_button_1 = require("../../../components/button/field.action.button");
var distance_input_1 = require("../../../components/input/distance.input");
var distance_input_state_1 = require("../../../components/input/distance.input.state");
var distance_input_style_1 = require("../../../components/input/distance.input.style");
var notification_service_1 = require("../../../components/notification.toast/notification.service");
var theme_1 = require("../../../components/theme");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var page_state_1 = require("../../../state/page.state");
var capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
exports.CSS = {
    container: 'c-PMLink',
    inputs: 'c-PMLink--inputs',
    isHovered: 'c-PMLink--hovered',
    isLinked: 'c-PMLink--linked',
    height: 'c-PMLink__Height'
};
exports.Styles = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex',
        'justify-content': 'space-between'
    },
    _a[exports.CSS.inputs] = (_b = {
            flex: 1,
            display: 'flex',
            'justify-content': 'space-between'
        },
        _b["& .".concat(distance_input_style_1.CSS.container)] = {
            width: '100%'
        },
        _b),
    _a[exports.CSS.isHovered] = {
        'font-weight': 'bold'
    },
    _a[exports.CSS.isLinked] = {
        cursor: 'pointer'
    },
    _a[exports.CSS.height] = {
        width: '100%'
    },
    _a);
(0, theme_1.addStyles)(exports.Styles);
function getValue(field, inputState) {
    if (field == null) {
        return 0;
    }
    var unit = services_1.Services.UserSettings.units;
    if (unit === core_shared_1.IkeUnit.METER) {
        var meters = inputState.meters.value || 0;
        return meters;
    }
    else {
        var inches = core_shared_1.IkeUnit.joinFeetInch(inputState.feet.value || 0, inputState.inch.value || 0);
        var meters = core_shared_1.IkeUnit.convert(inches, core_shared_1.IkeUnit.METER, core_shared_1.IkeUnit.INCH);
        return meters;
    }
}
function selectDrawable(draw, drawableId) {
    draw.state.setSelected(drawableId, null);
    return false;
}
function hoverDrawable(captureId, drawableId, hovered) {
    var draw = page_state_1.CurrentState.CollectionEdit.getIkeDraw(captureId);
    if (draw == null) {
        return;
    }
    if (hovered) {
        draw.state.setHovered(drawableId);
    }
    else if (draw.state.hoverId === drawableId) {
        draw.state.setHovered(null);
    }
}
exports.HeightFieldView = {
    viewInline: function (field) {
        return core_shared_1.IkeUnit.display(field.value, services_1.Services.UserSettings.units);
    },
    hasDetail: function (field) {
        return field.provider === IkeModel.CollectionModelFieldHeight.PROVIDER_SPAN_HEIGHT && field.getCaptures().length > 0;
    },
    viewDetail: function (field) {
        if (!exports.HeightFieldView.hasDetail(field)) {
            return null;
        }
        var capture = field.getCaptures()[0];
        var title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
        return capture_thumbnail_1.CaptureThumbnail.view(field.collection, capture, { crosshair: true, title: title });
    },
    viewEdit: function (field, ctrl) {
        var currentDraw = page_state_1.CurrentState.CollectionEdit.currentDraw;
        var canLinkTo = currentDraw != null && currentDraw.drawState.hasUserMeasurements();
        if (field.hasValue()) {
            var className = exports.CSS.container;
            var heightInline = exports.HeightFieldView.viewInline(field, ctrl);
            if ((field.isPhotoMeasure() || field.isPhotoMeasureManual()) && currentDraw != null) {
                var stateValue_1 = field.stateValue;
                var drawableId_1 = field.stateValue.drawable;
                // If the current field is hovered
                if (currentDraw.state.hoverId === drawableId_1) {
                    className = className + ' ' + exports.CSS.isHovered;
                }
                // If the current field is part of the currentDrawable allow it to select the drawable
                var onclick_1 = null;
                if (stateValue_1.captureId === currentDraw.capture.objectId) {
                    className = className + ' ' + exports.CSS.isLinked;
                    onclick_1 = function () { return selectDrawable(currentDraw, drawableId_1); };
                }
                // Set the hoverId for the drawable
                var onmouseover_1 = function () { return hoverDrawable(stateValue_1.captureId, drawableId_1, true); };
                var onmouseout_1 = function () { return hoverDrawable(stateValue_1.captureId, drawableId_1, false); };
                if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
                    var inputState_1 = ctrl.changeState.getState(field.id);
                    if (inputState_1 == null) {
                        inputState_1 = new distance_input_state_1.DistanceInputState(field.schema.displayName);
                        inputState_1.onValue(function () {
                            if (!distance_input_state_1.DistanceInputState.equal(field.value, inputState_1.value)) {
                                field.Mutator.manualFromInput(getValue(field, inputState_1));
                            }
                        });
                        inputState_1.meters.onValue(function () {
                            inputState_1.updateMetric();
                            if (!distance_input_state_1.DistanceInputState.equal(field.value, inputState_1.value) && inputState_1.meters.value != null) {
                                field.Mutator.manualFromInput(getValue(field, inputState_1));
                            }
                        });
                        inputState_1.feet.onValue(function () {
                            inputState_1.updateImperial();
                            if (!distance_input_state_1.DistanceInputState.equal(field.value, inputState_1.value) && inputState_1.feet.value != null) {
                                field.Mutator.manualFromInput(getValue(field, inputState_1));
                            }
                        });
                        inputState_1.inch.onValue(function () {
                            inputState_1.updateImperial();
                            if (!distance_input_state_1.DistanceInputState.equal(field.value, inputState_1.value) && inputState_1.inch.value != null) {
                                field.Mutator.manualFromInput(getValue(field, inputState_1));
                            }
                        });
                        ctrl.changeState.addState(field.id, inputState_1);
                        var val = field.value;
                        if (val != null) {
                            inputState_1.setValue(val);
                        }
                    }
                    //if one of the input state has focus, it means that we are currently manually updating the value
                    //In this case, we do not want to overwrite it with the value calculated from the current drawable position
                    //otherwise, we update the inputState with the value calculated from the drawable
                    if (!(inputState_1.focused || inputState_1.meters.focused || inputState_1.feet.focused || inputState_1.inch.focused)) {
                        var val = field.value;
                        if (val != null) {
                            inputState_1.setValue(val);
                        }
                    }
                    return (0, mithril_1.m)('div', { className: exports.CSS.inputs, onmouseover: onmouseover_1, onmouseout: onmouseout_1, onclick: onclick_1 }, [
                        distance_input_1.DistanceInput.view(inputState_1, services_1.Services.UserSettings.units)
                    ]);
                }
                else {
                    return (0, mithril_1.m)('div', { className: className, onmouseover: onmouseover_1, onmouseout: onmouseout_1 }, [
                        (0, mithril_1.m)('span', { className: exports.CSS.height, onclick: onclick_1 }, heightInline)
                    ]);
                }
            }
            return (0, mithril_1.m)('div', { className: className }, heightInline);
        }
        if (!canLinkTo) {
            return this.viewInline(field, ctrl);
        }
        var linkFieldIds = currentDraw.state.linkFieldIds;
        if (linkFieldIds.indexOf(field.id) !== -1) {
            return field_action_button_1.FieldActionButton.viewLinkHeight({
                linking: true,
                onclick: function () {
                    currentDraw.state.setTool(null);
                    currentDraw.state.setSelected(field.id, null);
                }
            });
        }
        // Some other field is being linked to
        if (linkFieldIds.length > 0) {
            return this.viewInline(field, ctrl);
        }
        // No fields are being linked show the link start behavior
        return field_action_button_1.FieldActionButton.viewLinkHeight({
            joinable: ctrl.getJoin(field) != null,
            onclick: function () {
                page_state_1.CurrentState.cancelInteractions();
                var oppositeJoin = ctrl.getOppositeJoin(field);
                if (oppositeJoin != null) {
                    currentDraw.state.setLinkFields([field.id, oppositeJoin.field.id]);
                    notification_service_1.NotificationService.info({ key: i18n_1.T.PHOTOMEASURE_JOIN_START, attrs: oppositeJoin.getTitle() });
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'measurement:join', ctrl.collection.revision, 1);
                }
                else {
                    services_1.Services.Analytics.trackTiming(core_api_1.TimingEventType.HOA, core_api_1.TimingEventAction.ENTER, currentDraw.collection.id, new Date());
                    currentDraw.state.setLinkFields([field.id]);
                }
            }
        });
    }
};
//# sourceMappingURL=height.field.view.js.map